import React from 'react';

import { useHistory } from 'react-router-dom';

import Box from 'components/atoms/Box/Box';
import Tile from 'components/molecules/Tile/Tile';
import GridContainer from 'components/atoms/GridContainer/GridContainer';
import GridItem from 'components/atoms/GridItem/GridItem';

export default function TileNavigation(props) {
  const history = useHistory();

  return (
    <Box pt={0.6} mb={3}>
      <GridContainer>
        {props.data.map((tileData) => (
          <GridItem xs={12} sm={12} md={6}>
            <Box p={'5px'}>
              <Tile
                leftIcon={tileData.primaryIcon}
                rightIcon={tileData.secondaryIcon}
                rightIconText={tileData.name}
                translationKey={tileData.translationKey}
                backgroundImage={tileData.tileBackgroundImage}
                onTileClick={() => {
                  history.push(tileData.route);
                }}
              />
            </Box>
          </GridItem>
        ))}
      </GridContainer>
    </Box>
  );
}
